const SECTION_LABELS = Object.freeze({
  hero: "Portada",
  spotlight: "Destacado principal",
  featured: "Destacados",
  brands: "Marcas",
  categories: "Categorías",
  about: "Nosotros / propuesta",
  highlights: "Diferenciales",
  contact: "Contacto",
  custom: "Sección personalizada",
});

const STOCK_BACKGROUND_TYPES = new Set(Object.keys(SECTION_LABELS));

function plainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function normalizedSegments(portable) {
  const segments = portable?.configuration?.layout?.segments;
  return Array.isArray(segments) ? segments : [];
}

export function missingStockBackgrounds(portable) {
  return normalizedSegments(portable).flatMap((segment, index) => {
    const type = String(segment?.type || "").trim();
    if (!STOCK_BACKGROUND_TYPES.has(type) || segment?.visible === false) return [];
    const imageUrl = String(segment?.visualStyle?.backgroundImageUrl || "").trim();
    if (imageUrl) return [];
    const id = String(segment?.id || `${type}-${index + 1}`);
    return [{
      key: `${id}:${index}`,
      id,
      index,
      type,
      label: type === "custom"
        ? String(segment?.data?.custom?.title || SECTION_LABELS.custom).trim() || SECTION_LABELS.custom
        : SECTION_LABELS[type],
    }];
  });
}

export function buildQuickDesignChatGptPrompt(portable, { includeStockImages = false, missingBackgrounds = [] } = {}) {
  if (!plainObject(portable)) return "";
  const missing = Array.isArray(missingBackgrounds) ? missingBackgrounds : [];
  const stockMode = includeStockImages && missing.length > 0;
  const missingText = missing.length
    ? missing.map((item) => `${item.label} (layout.segments.${item.index}.visualStyle.backgroundImageUrl)`).join("; ")
    : "ninguna";

  return [
    "Sos diseñador/a web senior. Vas a editar una configuración portable de WebProfit y devolverla lista para importar.",
    "",
    "OBJETIVO",
    "Mejorá el diseño y el contenido visual manteniendo los datos reales del negocio y respetando estrictamente el contrato incluido en manifest.",
    "",
    "FORMATO DE RESPUESTA OBLIGATORIO",
    "Devolvé SOLAMENTE el JSON completo importable por WebProfit. No escribas explicación, títulos, comentarios, Markdown ni texto antes o después del JSON. Conservá format, formatVersion, siteSettingsSchemaVersion y base exactamente como fueron recibidos. Modificá únicamente configuration.",
    "",
    "REGLAS DE CONTRATO",
    "- No inventes paths ni propiedades. Usá exclusivamente lo admitido por manifest.",
    "- Conservá todo campo que no necesites cambiar.",
    "- Respetá límites de texto, enums, rangos, capabilities y campos derivados indicados en manifest.",
    "- No agregues secretos, tokens, credenciales, estados de publicación ni datos internos.",
    "- No elimines imágenes existentes salvo que sea realmente necesario para mejorar el diseño.",
    "",
    "IMÁGENES Y FONDOS",
    stockMode
      ? `El usuario SÍ autorizó que VOS busques y agregues imágenes de stock. Hoy faltan fondos en: ${missingText}.`
      : `El usuario NO autorizó agregar automáticamente imágenes de stock. Fondos sin imagen detectados: ${missingText}.`,
    stockMode
      ? "- IMPORTANTE: no le pidas al usuario URLs, enlaces ni archivos. La búsqueda y selección de imágenes es parte de tu trabajo en esta respuesta."
      : "- Conservá vacíos los backgroundImageUrl que ya estén vacíos, salvo que el pedido explícito del usuario diga lo contrario.",
    stockMode
      ? "- Usá las herramientas de búsqueda web/imágenes disponibles para encontrar fotografías de stock, texturas o patrones visuales coherentes con el rubro, la marca y el contenido de cada sección."
      : "- Si ajustás colores, usá únicamente los campos de paleta admitidos por manifest.",
    stockMode
      ? "- Preferí fuentes de stock legítimas y públicamente accesibles (por ejemplo Unsplash, Pexels, Pixabay u otras equivalentes) y verificá que la referencia final sea una URL HTTPS pública que pueda cargarse directamente como imagen desde un navegador."
      : "",
    stockMode
      ? "- Podés usar Google u otro buscador PARA DESCUBRIR imágenes, pero NO insertes URLs de páginas de resultados, google.com/search, google.com/imgres, páginas HTML, previews del buscador ni enlaces inventados. Insertá la URL pública final de la imagen o CDN que el navegador pueda renderizar."
      : "",
    stockMode
      ? "- Para cada sección sin fondo elegí con criterio entre: (a) foto de stock del rubro, (b) textura/patrón como imagen, o (c) fondo sólido mediante la paleta local. No es obligatorio poner una foto en todas las secciones."
      : "",
    stockMode
      ? "- Para foto o patrón escribí directamente la URL elegida en layout.segments.*.visualStyle.backgroundImageUrl y ajustá backgroundImagePosition si hace falta. Para un fondo sólido no inventes una imagen: usá visualStyle.useGlobalColors=false y visualStyle.colors.background cuando el contrato de esa sección lo permita."
      : "",
    stockMode
      ? "- No uses URLs temporales, firmadas con vencimiento ni enlaces que requieran login. Si una imagen no puede verificarse como pública y estable, buscá otra; no le traslades esa tarea al usuario."
      : "",
    stockMode
      ? "- También podés completar imageUrl/logoUrl existentes cuando sea visualmente pertinente y esos paths estén admitidos por manifest, sin reemplazar datos de marca reales por imágenes genéricas."
      : "- Conservá las imágenes existentes y no agregues nuevas imágenes externas.",
    "",
    "CRITERIO DE DISEÑO",
    "Mantené coherencia de marca, contraste legible, jerarquía clara y una estética consistente entre secciones. Las imágenes elegidas deben tener relación directa con el rubro y no deben dificultar la lectura del contenido.",
    "",
    "CONFIGURACIÓN WEBPROFIT A EDITAR",
    JSON.stringify(portable, null, 2),
  ].filter((line) => line !== "").join("\n");
}
